module.exports = __webpack_public_path__ + "assets/img/CUA-Social-Static-Ad-w720.1474adca.webp";